/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-navigation-caret-right': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M8.125 5.625l5 4.375-5 4.375z"/>'
  }
})
